import clsx from "clsx";
import { useCallback, useState } from "react";

import ArrowDown from "../../assets/icons/arrow-down.svg";

import Button from "../button";

import styles from "./collapsed-question.module.scss";

function CollapsedQuestion({ question, answer }) {
  const [showAnswer, setShowAnswer] = useState(false);

  const toggleQuestion = useCallback(() => {
    setShowAnswer((v) => !v);
  }, []);

  return (
    <div className={styles.CollapsedQuestion}>
      <div className={styles.CollapsedHeader}>
        <div className={styles.QuestionWrapper}>
          <h4>{question}</h4>
        </div>
        <div className={styles.ToggleWrapper}>
          <Button
            clear
            className={styles.Toggle}
            type="button"
            onClick={toggleQuestion}
          >
            <ArrowDown
              className={clsx(styles.ArrowIcon, showAnswer && styles.Rotate)}
              role="presentation"
              fill="#000000"
            />
          </Button>
        </div>
      </div>

      <div
        className={clsx(styles.CollapsibleContent, showAnswer && styles.Show)}
      >
        <div
          className={clsx(styles.Content)}
          dangerouslySetInnerHTML={{ __html: answer }}
        ></div>
      </div>
    </div>
  );
}

export default CollapsedQuestion;
